import { createStore } from 'redux';
import { persistStore } from 'redux-persist';

import { enhancers } from './enhancers';
import { rootReducer, initialState } from './reducers';

export const store = createStore(rootReducer, initialState, enhancers);
export const persistor = persistStore(store);
